<template>
  <div>
    <v-row>
      <v-col cols="12">
        <synthesis-risk-summary-block />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <synthesis-risk-methods-block />
      </v-col>
    </v-row>
  </div>
</template>

<script>

import SynthesisRiskSummaryBlock from '@/theme/default/views/banking/risk/interest-rate/NII/blocks/SynthesisRiskSummaryBlock'
import SynthesisRiskMethodsBlock from '@/theme/default/views/banking/risk/interest-rate/NII/blocks/SynthesisRiskMethodsBlock'

export default {
  name      : 'SynthesisRisk',
  components: {
    SynthesisRiskSummaryBlock,
    SynthesisRiskMethodsBlock
  }
}
</script>

<style scoped>

</style>
